import api from "./api";

export const getsDescuentoCatalogo = async () => {
    const response = await api.get("/DescuentoCatalogo/GetsDescuentoCatalogo");
    return response.data.data;
}

export const getsDescuentoCatalogoActivos = async () => {
    const response = await api.get("/DescuentoCatalogo/GetsDescuentoCatalogoActivos");
    return response.data.data;
}

export const getDescuentoCatalogo = async (id) => {
    const response = await api.get("/DescuentoCatalogo/GetDescuentoCatalogo?idDescuentoCatalogo=" + id);
    return response.data.data;
}

export const addUpdateDescuentoCatalogo = async (dataPost) => {
    const response = await api.post("/DescuentoCatalogo/AddUpdateDescuentoCatalogo", dataPost);
    return response.data.data;
}

export const annulDescuentoCatalogo = (id) =>
    api.post("/DescuentoCatalogo/AnnulDescuentoCatalogo?idDescuentoCatalogo=" + id);

export const activeDescuentoCatalogo = (id) =>
    api.post("/DescuentoCatalogo/ActiveDescuentoCatalogo?idDescuentoCatalogo=" + id);

export default {
    getsDescuentoCatalogo,
    getsDescuentoCatalogoActivos,
    getDescuentoCatalogo,
    addUpdateDescuentoCatalogo,
    annulDescuentoCatalogo,
    activeDescuentoCatalogo,
};